export function showToast(message, type = "success") {
  const template = document.getElementById(`toast-template-${type}`);
  const container = document.getElementById("flash-messages");

  if (!template || !container) return;

  const node = template.content.cloneNode(true);
  const messageEl = node.querySelector("[data-toast-message]");
  
  if (messageEl) messageEl.textContent = message;
  container.appendChild(node);
}
